/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from "react";
import alertSvg from "assets/alert.svg";
import "./styles.css";

/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable react/button-has-type */

const AlertContext = React.createContext(null);
AlertContext.displayName = "AlertContext";

function AlertProvider({ children }) {
  const AlertStatus = {
    Success: "Success",
    None: "NONE",
    Info: "Info",
    Error: "Error",
  };
  const [alert, setAlert] = useState(AlertStatus.None);
  const [alertText, setAlertText] = useState(null);
  const [alertErrorMessage, setAlertErrorMessage] = useState(null);

  const [callbackTrigger, setCallbackTrigger] = useState(false);

  return (
    <AlertContext.Provider
      value={{
        alert,
        alertErrorMessage,
        alertText,
        callbackTrigger,

        success: (text, timeout) => {
          setAlertText(text);
          setAlert(AlertStatus.Success);
          setTimeout(() => {
            setAlert(AlertStatus.None);
          }, timeout * 1000 || 10000);
        },

        error: (errorMessage, text, timeout, callback) => {
          setAlertText(text);
          setAlert(AlertStatus.Error);
          setAlertErrorMessage(errorMessage);
          setCallbackTrigger(() => callback);
          setTimeout(() => {
            setAlert(AlertStatus.None);
          }, timeout * 1000 || 10000);
        },

        info: (text) => {
          setAlertText(text);
          setAlertErrorMessage(null);
          setAlert(AlertStatus.Info);
        },

        clear: () => setAlert(AlertStatus.None),
      }}
    >
      {children}
    </AlertContext.Provider>
  );
}

export { AlertProvider };
export default AlertContext;

export function ModalAlert() {
  const { alertErrorMessage, clear, alertText, alert, callbackTrigger } =
    useContext(AlertContext);

  const handleButtonClick = () => {
    if (callbackTrigger) {
      callbackTrigger();
      clear();
    }
  };

  if (alert !== "NONE") {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 99,
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "24px 32px 20px",
            borderRadius: 16,
          }}
        >
          {alertErrorMessage && (
            <div className="alert--alertErrorMessage">
              <img
                src={alertSvg}
                alt="download app"
                style={{ height: 12, marginRight: 4 }}
              />
              {alertErrorMessage}
            </div>
          )}
          <div className="alert-alertTitle">{alertText}</div>
          {alert !== "Info" && (
            <button className="alert-alertButton" onClick={handleButtonClick}>
              Submit Round
            </button>
          )}
          <button className="alert-alertButton-close" onClick={clear}>
            Back to Match
          </button>
        </div>
      </div>
    );
  }
  return null;
}
